var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, cloneElement } from 'react';
import classnames from 'classnames';
import { BreadcrumbLink } from './BreadcrumbLink';
export const Breadcrumb = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    const BreadcrumbClasses = classnames('Breadcrumb', className);
    const links = Children.toArray(children).filter((child) => child);
    return (React.createElement("ul", Object.assign({ "aria-label": "breadcrumbs", className: BreadcrumbClasses, "data-anvil-component": "Breadcrumb" }, props), links.map((child, i) => {
        var _a;
        return cloneElement(child, i === links.length - 1 && !((_a = child.props) === null || _a === void 0 ? void 0 : _a['aria-current'])
            ? { 'aria-current': 'location' }
            : null);
    })));
};
Breadcrumb.Link = BreadcrumbLink;
//# sourceMappingURL=Breadcrumb.js.map